import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    airtable_config_get_label,
    changeExternalId,
    checkboxesSave,
    checkChange,
    hoverAll,
    selectAll
} from "../redux/actions";

export const Subscriptions = () => {
    const dispatch = useDispatch()
    const locale = useSelector(state => state.app.locale)
    const configData = useSelector(state => state.app.configData)
    const important_title = configData !== null ? airtable_config_get_label(configData, 'important', locale) : null;
    const select_all_title = configData !== null ? airtable_config_get_label(configData, 'select_all', locale) : null;
    const save_title = configData !== null ? airtable_config_get_label(configData, 'save', locale) : null;
    const lang_title = configData !== null ? airtable_config_get_label(configData, 'subscription_change_lang', locale) : null;
    const subscriptionsData = useSelector(state => state.app.subscriptionsData)
    const customer = useSelector(state => state.app.customer)
    const subscriptions = useSelector(state => state.app.subscriptions)
    const subscriptionChange = useSelector(state => state.app.subscriptionChange)
    const saveBtn = useSelector(state => state.app.saveBtn)
    const selectAllBtn = useSelector(state => state.app.selectAllBtn)
    const userEmail = useSelector(state => state.app.userEmail)
    const userMarker = useSelector(state => state.app.userMarker)
    const area = useSelector(state => state.app.area)
    const cis = useSelector(state => state.app.cis)
    const hover = useSelector(state => state.app.hoverAll)
    let customer_lang = 'en';
    const handleItemClick = (item, index) => {
        dispatch(checkChange(item, index))
    }
    const handleSelectAllClick = () => {

        dispatch(selectAll())
    }
    const handleSaveClick = (customer, subscriptions, userEmail,userMarker, area) => {
        dispatch(checkboxesSave(customer, subscriptions, userEmail,userMarker, area))
    }
    const handleClickLang = (lang) => {
        console.log(lang)
        dispatch(changeExternalId(lang));
    }

    const handleHoverAll = (hover) => {
        dispatch(hoverAll(hover));
    }

    if (subscriptionsData === null || subscriptions == null) {
        return null;
    }
    if (area !== undefined && area.ids !== undefined && area.ids.externalId !== undefined) {
        customer_lang = area.ids.externalId;
    }

    return (
        <section className="subscriptions container">
            <div className="container__wrap">
                <div className="subscriptions__control">
                    {
                        subscriptionChange
                    }
                    {
                        selectAllBtn && (
                            <div className="subscriptions__select_all checked"
                                 onClick={() => handleSelectAllClick()}
                                 onMouseEnter={() => handleHoverAll(true)}
                                 onMouseLeave={() => handleHoverAll(false)}
                            >{select_all_title}
                            </div>)
                    }
                    {
                        !selectAllBtn && (
                            <div className="subscriptions__select_all"
                                 onClick={() => handleSelectAllClick()}
                                 onMouseEnter={() => handleHoverAll(true)}
                                 onMouseLeave={() => handleHoverAll(false)}
                            >{select_all_title}
                            </div>)
                    }
                    {
                        ((locale === 'ru') || (locale === 'en' && cis === 'true'))  && (
                            <div className="subscriptions__lang">
                                <div className="subscriptions__lang_label">{lang_title}</div>
                                {
                                    customer_lang === 'ru' && (<React.Fragment>
                                        <div className="subscriptions__lang_radio checked">RU</div>
                                        <div className="subscriptions__lang_radio"
                                             onClick={() => handleClickLang('en')}>EN
                                        </div>
                                    </React.Fragment>)
                                }
                                {
                                    customer_lang === 'en' && (<React.Fragment>
                                        <div className="subscriptions__lang_radio"
                                             onClick={() => handleClickLang('ru')}>RU
                                        </div>
                                        <div className="subscriptions__lang_radio checked">EN</div>
                                    </React.Fragment>)
                                }

                            </div>)
                    }
                </div>
                {
                    subscriptionsData.map(function (s_item, s_index) {
                        let className = 'subscriptions__item';
                        for (let i = 0; i < subscriptions.length; i++) {
                            if (subscriptions[i].brand === s_item.fields.brand && subscriptions[i].topic === s_item.fields.topic && s_item.fields.lang === locale) {
                                let important = s_item.fields.important ? true : false;
                                if (subscriptions[i].isSubscribed === true) {
                                    className += ' checked';
                                }
                                if (hover === true) {
                                    className += ' hover';
                                }
                                return (
                                    <div key={s_index} className={className}
                                         onClick={() => handleItemClick(subscriptions[i], i)}>
                                        <div
                                            className="subscriptions__item_title">{s_item.fields.title} {important && (
                                            <div
                                                className="subscriptions__item_important">{important_title}</div>)}</div>
                                        <div
                                            className="subscriptions__item_description">{s_item.fields.description}</div>
                                    </div>
                                )
                            }
                        }
                        return null;
                    })


                }
                {
                    1 === 2 && subscriptions.map(function (item, index) {
                        let className = 'subscriptions__item';
                        for (let i = 0; i < subscriptionsData.length; i++) {
                            if (item.brand === subscriptionsData[i].fields.brand && item.topic === subscriptionsData[i].fields.topic && subscriptionsData[i].fields.lang === locale) {
                                let important = subscriptionsData[i].fields.important ? true : false;
                                if (item.isSubscribed === true) {
                                    className += ' checked';
                                }
                                return (
                                    <div key={index} className={className} onClick={() => handleItemClick(item, index)}>
                                        <div
                                            className="subscriptions__item_title">{subscriptionsData[i].fields.title} {important && (
                                            <div
                                                className="subscriptions__item_important">{important_title}</div>)}</div>
                                        <div
                                            className="subscriptions__item_description">{subscriptionsData[i].fields.description}</div>
                                    </div>
                                )
                            }
                        }
                        return null;
                    })
                }
                <div className="subscriptions__control2">
                    {
                        saveBtn && (
                            <div className="subscriptions__save"
                                 onClick={() => handleSaveClick(customer, subscriptions, userEmail,userMarker, area)}>{save_title}</div>)
                    }
                    {
                        !saveBtn && (<div className="subscriptions__save disabled">{save_title}</div>)
                    }
                </div>
                {
                    saveBtn && (<div className="subscriptions__btn_overlay"/>)
                }
            </div>
        </section>
    )
}